import "./Footer.css";
import Amahle from "./images/amahle-logo.png";
import {Link} from "react-router-dom";

const Footer = ({redirectToTop}) => {
    return ( 
        <>
            <div className="footer">
                <div className="footer-content">
                    <img src={Amahle} alt="" />
                    <div className="headings">
                        <h2>Amahle-Amashenge</h2>
                        <ul>
                            <li><Link to="/" onClick={redirectToTop}>Home</Link></li>
                            <li><Link to="/about" onClick={redirectToTop}>About Us</Link></li>
                            <li><Link to="/service" onClick={redirectToTop}>Services</Link></li>
                            <li><Link to="/contact" onClick={redirectToTop}>Contact</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="footer-notes">
                    <p>
                        <i className="fa fa-copyright" aria-hidden="true"></i> 2023 Amahle-Amashenge Holdings (Pty) Ltd. All Rights Reserved
                    </p>

                    <div className="icons">
                        <a href="https://instagram.com"><i className="fa fa-instagram"></i></a>
                        <a href="https://facebook.com"><i className="fa fa-facebook"></i></a>
                        <a href="https://linkedin.com"><i className="fa fa-linkedin"></i></a>
                        <a href="https://x.com"><i className="fa fa-twitter"></i></a>
                        
                        
                    </div>
                </div>
            </div>
            
        </>
     );
}
 
export default Footer;